module.exports = "/fast-coin/img/coin/anim/in/coin_in_017.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/in/coin_in_017.png
// module id = 2287
// module chunks = 5